import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import NumberFieldItemEdit from "./edit-item";

const NumberFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <NumberFieldItemEdit />
        </FieldListEditWrapper>
    );
};
NumberFieldEdit.displayName = "NumberFieldEdit";
export { NumberFieldEdit };
